module.exports = __webpack_public_path__ + "logo-with-title-black.svg";